import React from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody } from "reactstrap";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Options from "./Options";

const Reports = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Reportes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Reportes"} />
          <div className="d-flex justify-content-center">
            <Card
              style={{
                width: "70rem",
              }}
            >
              <CardBody>
                <Options />
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Reports;
